<template>
    <div class="error-page d-flex flex-column align-items-center justify-content-center pa-10">
        <h1>
            {{ $t('general.404.title') }}
        </h1>

        <y-button
            tag="router-link"
            to="/"
            color="font"
            size="small"
        >
            {{ $t('general.404.back_to_home') }}
        </y-button>
    </div>
</template>

<script>
    import PageMixin from '@groot-nodes/mixins/Page.js';

    export default {
        name: 'Error404',

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('general.404.title'),
            };
        },
    };
</script>
